import { ApplicationState } from "reducers";

export class AuthSelectors {
    public static isLoggedIn(state: ApplicationState): boolean {
        return !!state.auth.refreshToken;
    }
}
